import type React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';
import { useInjection } from 'inversify-react';
import type { AppController } from '@/engine/app/App.controller';
import { TYPES } from '@/engine/ioc';
import { observer } from 'mobx-react';

export const ProgressOverlay: React.FC = observer(() => {
  const appController = useInjection<AppController>(TYPES.AppController);

  return (
    <div>
      {appController.progressOverlayMessage ? (
        <Container data-testid={'report-generation-overlay'}>
          {appController.progressOverlayMessage.map((line, index) => (
            <div key={`message-line-${index}`}>{line}</div>
          ))}
          <p>
            <CircularProgress size={'4em'} style={{ marginTop: '15px' }} />
          </p>
          <div>Please do not leave the page.</div>
        </Container>
      ) : (
        ''
      )}
    </div>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: fixed;
  width: 100%;
  height: 100%;
  transition: 0.5s ease-in-out;
  z-index: 1000;
  background-color: #d4d4d4;
`;
